import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const EndOfDocumentExtension = Extension.create({
  name: 'endOfDocument',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('endOfDocument'),
        props: {
          decorations: (state) => {
            const decorations = DecorationSet.create(state.doc, [
              Decoration.widget(
                state.doc.content.size,
                () => {
                  const div = document.createElement('div');

                  div.style.width = '100%';
                  div.style.height = '80px';

                  return div;
                },
                {
                  side: 1,
                  stopEvent: () => true,
                  ignoreSelection: true,
                },
              ),
            ]);

            return decorations;
          },
        },
      }),
    ];
  },
});
